import React from 'react';
import { Button, Spacer, HStack } from '@chakra-ui/react';

type Props = {
  onSave: () => void;
  onCancel: () => void;
  isDisabled: boolean;
};

export const SaveCancelButtons: React.VFC<Props> = ({
  onSave,
  onCancel,
  isDisabled,
}) => (
  <HStack spacing="5" w="full" borderTopWidth="1px" pt="5">
    <Spacer />
    <Button
      colorScheme="webInterview"
      w="36"
      onClick={onSave}
      isDisabled={isDisabled}
    >
      保存
    </Button>
    <Button w="36" onClick={onCancel}>
      キャンセル
    </Button>
  </HStack>
);
